import {bindActionCreators} from 'redux'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import ReactCookie from 'react-cookie'
import request from 'superagent';
import DetailSelect from '../components/DetailSelect'
import Top from '../components/Top'
import Disease from '../components/Disease'
import Cancer from '../components/Cancer'
import Sevens from '../components/Sevens'
import Constitution from '../components/Constitution'
import Risklevel from '../components/Risklevel'
import Header from '../components/Header'
import Footer from '../components/Footer'
import {Help,HelpHow,HelpFaq,HelpDic} from '../components/Help'
import {modalOpen} from '../actions/Modal'
import Covid19 from '../components/Covid19'
import Buyapp from '../components/Buyapp'
import {
  URL_INFO,
  URL_SEARCH_ITEM,
  USER_COMMUNICATION_BOOK,
  URL_GET_AFFILIATE_AGREEMENTS,
  MYPAGE_URL
} from '../constants/Url'
import {LscContent} from '../components/LscContent'
import {AffiliateRecommend} from "../components/AffiliateRecommend";
import {AFFILIATE_RECOMMEND, GENE, SHINAGAWA_BFF_API_KEY} from "../constants/EnvItems";
import { BrowserRouter, Route, Redirect } from 'react-router-dom'
import QvcBigDiscovery from "../components/QvcBigDiscovery";

class App extends Component {

  constructor(props) {
    super(props)
    this.setPage = this.setPage.bind(this)
    this.openDietResult = this.openDietResult.bind(this)
    this.togglePageTop = this.togglePageTop.bind(this)
    this.toggleResultBack = this.toggleResultBack.bind(this)
    this.state = {
      page: "Top",
      err_msg: '',
      access_token: '',
      kit: '',
      show: "",
      toggleMenu: false,
      toggleResult: false,
      toggleSearch: false,
      nickname: "",
      gender: '',
      isDetail: false,
      detail: null,
      info: null,
      profile: [],
      gene: ReactCookie.load(GENE),
      dataSearchResult: [],
      subtypes: null,
      affiliate_agreed: false,
      customer_id: null,
      special_kit_codes: []
    }
    this.dataSearchResultMaster = []

  }

  setPage(page) {
    this.setState({
      page: page,
      toggleResult: false,
    });
    window.scrollTo(0, 0);
  }

  toggleResultBack() {
    this.setState({toggleResult: false})
  }

  toggleMenu() {
    this.setState({toggleMenu: !this.state.toggleMenu})
  }

  toggleResult() {
    this.setState({toggleResult: !this.state.toggleResult})
  }

  toggleSearch(buf) {
    let toggleSearch = (buf !== "");
    let dataSearchResult = [];
    if(toggleSearch){
      for(let i=0; i<this.dataSearchResultMaster.length; i++){
        if(!(this.dataSearchResultMaster[i].name.indexOf(buf) === -1 && this.dataSearchResultMaster[i].hiragana.indexOf(buf) === -1 && this.dataSearchResultMaster[i].katakana.indexOf(buf) === -1)){
          dataSearchResult.push({id: this.dataSearchResultMaster[i].id, name: this.dataSearchResultMaster[i].name})
        }
      }
    }
    this.setState({toggleSearch: toggleSearch, dataSearchResult: dataSearchResult})
  }

  toggleGender() {
    let gender = 'female' === this.state.gender ? 'male' : 'female';
    this.setSearchItem(gender);
    this.setState({
      gender: gender,
    })
  }

  togglePageTop() {
    this.setState({page: "Top"})
  }

  setInfo() {

    request
      .get(URL_INFO(this.state.gene))
      .set('Content-Type', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log('error')
        }

        if (process.env.NODE_ENV === 'production') {
          if (res.body.status === 'ng') {
            window.alert('<セッションタイムアウト>\n\n最後のログインからしばらく時間が経過したため、ログイン状態が解除されました。\n再度ログインをお願いします。');
            window.location.href = "https://genelife.jp/auth/login";
          }
          // GE系キット保有者のみ許可（ホワイトリスト方式）
          // GE6（アプリ専用）や非GE系キットのみのユーザーが Genesis 2.0 結果を閲覧できないようにする
          var kit = (res.body.kit_code || '').toUpperCase();
          if (!kit.startsWith('GE') || kit.startsWith('GE6')) {
            window.location.href = MYPAGE_URL;
            return;
          }
          this.setState({
            access_token: res.body.access_token,
            kit: res.body.kit_code,
            nickname: res.body.nickname,
            gender: res.body.gender,
            customer_id: res.body.customer_id,
            special_kit_codes: res.body.special_kit_codes,
          })
          this.setCommunicationBook()
        } else {
          this.setState({
            access_token: '__key_for_test__',
            kit: 'GE00006978',
            nickname: 'mitsuki',
            gender: 'female',
            customer_id: 123085,
            special_kit_codes: ['exempt_lsc', 'big_discovery'],
          })
          this.setCommunicationBook()
        }
      });
      this.setSearchItem(this.state.gender);
  };

  setSearchItem(gender) {
    request
      .get(URL_SEARCH_ITEM(gender))
      .set('Content-Type', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log('error')
          return;
        }
        this.dataSearchResultMaster = res.body.units;
      })
  }

  setCommunicationBook() {
    request
      .get(USER_COMMUNICATION_BOOK(this.state.access_token, this.state.kit))
      .set('Content-Type', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log('error')
        }

        if (res) {
          this.setState({
            lsc_status: res.body.status,
            lsc_result: res.body.result
          })
          if (AFFILIATE_RECOMMEND) {
            this.getAffiliateAgreements();
          }
        }
      })
  }

  getAffiliateAgreements() {
    request
        .get(URL_GET_AFFILIATE_AGREEMENTS(this.state.customer_id))
        .set('Accept', 'application/json')
        .set('x-api-key', SHINAGAWA_BFF_API_KEY)
        .set('Content-Type', 'application/json')
        .end((err, res) => {
          if (err) {
            console.log('error', err)
            return;
          }
          if (res.status === 200) {
            if (res.body.agreed_at !== undefined) {
              this.setState({
                affiliate_agreed: true
              })
            }
          }
        });
  }

  componentWillMount() {
    this.setInfo()
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // ブラウザバックをした際に、「検索結果を見る」を非表示にする対応
    window.addEventListener("popstate", this.toggleResultBack)
  }

  handleModalOpen(unit_id) {

    this.props.modalOpen(true);
    document.body.style.overflow = "hidden";
    this.props.modalOpen(true);
    // ブラウザバックで結果詳細画面に戻った際にセッションエラーにさせたくないのでリターン
    if (isNaN(unit_id)) {
      return
    }
    this.setState({isDetail: true, detail: unit_id, unit_id: unit_id, toggleResult: false});
  }

  handleModalClose() {
    document.body.style.overflow = "auto";
    this.props.modalOpen(false)
    this.setState({isDetail: false})
  }

  openDietResult() {
    let unit_id = 'female' === this.state.gender ? 948 : 947;
    this.handleModalOpen(unit_id)
  }

  openAffiliateResult(gene_details, subtypes) {

    this.setState( {gene_details , subtypes, page: 'recommendation', toggleResult: false });
    this.handleModalClose();

  }

  render() {
    const {show} = this.props
    const {page, toggleMenu, toggleResult, toggleSearch, nickname, gender, subtypes} = this.state;
    return (
      <BrowserRouter>
        <div>
          <div id="l-wrapper" className="l-wrapper">
            <div className="c-container">
              <div className="modal_header">
                <Header
                    dataSearchResult={this.state.dataSearchResult}
                    toggleSearch={toggleSearch}
                    toggleSearchMethod={this.toggleSearch.bind(this)}
                    toggleMenu={toggleMenu}
                    toggleMenuMethod={this.toggleMenu.bind(this)}
                    toggleResult={toggleResult}
                    toggleResultMethod={this.toggleResult.bind(this)}
                    toggleGenderMethod={this.toggleGender.bind(this)}
                    handleModalOpen={(e) => this.handleModalOpen(e)}
                    handleModalClose={this.handleModalClose.bind(this)}
                    switchPageMethod={this.setPage.bind(this)}
                    kit={this.state.kit}
                    lsc_status={this.state.lsc_status}
                    lsc_result={this.state.lsc_result}
                    page={page}
                    unit_id={this.state.unit_id}
                    nickname={nickname}
                    gender={gender}
                    special_kit_codes={this.state.special_kit_codes}
                />
                <Route exact path="/" render={props => <Top
                    access_token={this.state.access_token}
                    kit={this.state.kit}
                    customer_id={this.state.customer_id}
                    lsc_status={this.state.lsc_status}
                    lsc_result={this.state.lsc_result}
                    setPage={this.setPage}
                    toggleResult={toggleResult}
                    toggleResultMethod={this.toggleResult.bind(this)}
                    switchPageMethod={this.setPage.bind(this)}
                    handleModalOpen={(e) => this.handleModalOpen(e)}
                    nickname={nickname}
                    openDietResult={this.openDietResult}
                    affiliate_agreed={this.state.affiliate_agreed}
                    special_kit_codes={this.state.special_kit_codes}
                    togglePageTop={this.togglePageTop}
                />} />

                <Route path="/detail" render={props => {
                  return <DetailSelect
                    access_token={this.state.access_token}
                    handleModalOpen={(e, id) => this.handleModalOpen(e, id)}
                    handleModalClose={(e) => this.handleModalClose(e)}
                    show={show}
                    unit_id={this.state.unit_id}
                    token={this.state.access_token}
                    kit={this.state.kit}
                    gender={gender}
                    openAffiliateResult={(detail,  subtypes) => this.openAffiliateResult(detail, subtypes)}
                    affiliate_agreed={this.state.affiliate_agreed}
                    location={props.location}
                    history={props.history}
                />}} />
                <Route path="/disease" render={props => {
                  return <Disease
                      access_token={this.state.access_token}
                      kit={this.state.kit}
                      unit_id={this.state.unit_id}
                      gender={gender}
                      toggleResult={toggleResult}
                      toggleResultMethod={this.toggleResult.bind(this)}
                      switchPageMethod={this.setPage.bind(this)}
                      special_kit_codes={this.state.special_kit_codes}
                      handleModalOpen={(e) => this.handleModalOpen(e)}
                      handleModalClose={(e) => this.handleModalClose(e)} />
                }} />
                <Route path="/constitution" render={props => {
                  return <Constitution
                      access_token={this.state.access_token}
                      kit={this.state.kit}
                      unit_id={this.state.unit_id}
                      gender={gender}
                      handleModalOpen={(e) => this.handleModalOpen(e)}
                      handleModalClose={(e) => this.handleModalClose(e)}/>
                }}/>
                <Route path="/risklevel" render={props => {
                  return <Risklevel
                      access_token={this.state.access_token}
                      kit={this.state.kit}
                      unit_id={this.state.unit_id}
                      gender={gender}
                      handleModalOpen={(e) => this.handleModalOpen(e)}
                      handleModalClose={(e) => this.handleModalClose(e)}/>
                }}/>
                <Route path="/cancer" render={props => {
                  return <Cancer
                    access_token={this.state.access_token}
                    kit={this.state.kit}
                    unit_id={this.state.unit_id}
                    gender={gender}
                    handleModalOpen={(e) => this.handleModalOpen(e)}
                    handleModalClose={(e) => this.handleModalClose(e)}/>
                }}/>
                <Route path="/sevens" render={props => {
                  return <Sevens
                      access_token={this.state.access_token}
                      kit={this.state.kit}
                      unit_id={this.state.unit_id}
                      gender={gender}
                      handleModalOpen={(e) => this.handleModalOpen(e)}
                      handleModalClose={(e) => this.handleModalClose(e)}
                      switchPageMethod={this.setPage.bind(this)}/>
                }} />
                <Route path="/lsc_content" render={props => {
                  return <LscContent
                      access_token={this.state.access_token}
                      kit={this.state.kit}
                      lsc_status={this.state.lsc_status}
                      lsc_result={this.state.lsc_result}
                      switchPageMethod={this.setPage.bind(this)}
                      nickname={nickname}
                  />
                }}/>
                <Route path="/add10" render={props => {
                  return <QvcBigDiscovery
                      access_token={this.state.access_token}
                      kit={this.state.kit}
                      unit_id={this.state.unit_id}
                      gender={gender}
                      handleModalOpen={(e) => this.handleModalOpen(e)}
                      handleModalClose={(e) => this.handleModalClose(e)}
                  />
                }}/>

                <Route path="/covid19" render={props => {
                  return <Covid19
                      access_token={this.state.access_token}
                      kit={this.state.kit}
                      unit_id={this.state.unit_id}
                      gender={gender}
                      handleModalOpen={(e) => this.handleModalOpen(e)}
                      handleModalClose={(e) => this.handleModalClose(e)}
                      switchPageMethod={this.setPage.bind(this)}/>
                }} />

              <Route path="/buyapp" render={props => {
                  return <Buyapp
                      access_token={this.state.access_token}
                      kit={this.state.kit}
                      unit_id={this.state.unit_id}
                      gender={gender}
                      handleModalOpen={(e) => this.handleModalOpen(e)}
                      handleModalClose={(e) => this.handleModalClose(e)}
                      switchPageMethod={this.setPage.bind(this)}/>
                }} />

                <Route path="/help" render={props => {
                  return <Help
                      switchPageMethod={this.setPage.bind(this)}/>
                }}/>
                <Route path="/help_result" render={props => {
                  return <HelpHow
                      switchPageMethod={this.setPage.bind(this)}/>
                }}/>

                <Route path="/help_faq" render={props => {
                  return <HelpFaq
                      switchPageMethod={this.setPage.bind(this)}/>
                }}/>

                <Route path="/help_dictionary" render={props => {
                  return <HelpDic
                      switchPageMethod={this.setPage.bind(this)}/>
                }}/>

                <Route path="/recommendation"  render={props => <AffiliateRecommend subtypes={subtypes} />}/>

                <Route render={() => <Redirect to="/" />} />

              </div>
              <div className="modal_footer">
                <Footer
                    handleModalOpen={this.handleModalOpen.bind(this)}
                    handleModalClose={this.handleModalClose.bind(this)}
                />
              </div>
            </div>
          </div>
          <div id="r-wrapper" className="l-wrapper"/>
        </div>
      </BrowserRouter>
    )
  }
}

function mapStateToProps(state) {
  return {
    show: state.Modal.show
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, {modalOpen}), dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/containers/App.js